/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanProductAccountSettingItemInputDto { 
    id?: number;
    loanProductId?: number;
    accountId?: number;
    accountLedgerName?: string | null;
    accountName?: string | null;
    accountCode?: string | null;
    ledgerType?: string | null;
    chargeType?: string | null;
}

